import * as Objects from './Objects.js';
import * as config from '@/config';
import * as AwsSigningUtils from '@/library/utils/aws-signing';

// Recuperar URLs desde ambiente
const URL_API_BOLETAS = config.URL_API_BOLETAS;

export const TIPOS_DTE = {
	BOLETA_AFECTA_ELECTRONICA: 39,
	BOLETA_EXENTA_ELECTRONICA: 41,
};

export const RECEPTOR_GENERICO = {
	RUT: 66666666,
	DV: 6,
	RAZON_SOCIAL: 'SII Boleta',
	COMUNA: 'Santiago',
	DIRECCION: 'Santiago',
};

const DUMMY_FUN = function(){};

export class ApiBoletas {
	static urlDteFinal() {
		return `/api/dte/documentos/generar`;
	}
	static añadirUrlBase(url) {
		return `${ApiBoletas.urlBase}${url}`;
	}
	static get urlBase() {
		// Depende de etapa de desarrollo, obtener valor del ambiente.
		return URL_API_BOLETAS;
	}
}

export class Boleta {
	constructor(tipoDte, emisor, receptor, detalle) {
		this.tipoDte = tipoDte;
		this.emisor = emisor;
		this.receptor = receptor;
		this.detalle = detalle;
		this.dteFinalSuccessCallback = undefined;
		this.dteFinalFailCallback = undefined;
		this.vendedor = undefined;
		this.meta = undefined;
	}
	set tipoDte(x) {
		let tiposDtePermitidos = Object.values(TIPOS_DTE);
		if(!tiposDtePermitidos.includes(x)) {
			throw new Error(`Atributo tipoDte no tiene un valor permitido (${x})`);
		}
		this.__tipoDte = x;
	}
	get tipoDte() {
		return this.__tipoDte;
	}
	set emisor(x) {
		if(!(x instanceof Objects.Emisor)) { 
			throw new Error(`Atributo emisor no es instancia de Emisor`);
		}
		this.__emisor = x;
	}
	get emisor() {
		return this.__emisor;
	}
	set receptor(x) {
		if(!(x instanceof Objects.Receptor)) { 
			throw new Error(`Atributo emisor no es instancia de Receptor`);
		}
		this.__receptor = x;
	}
	get receptor() {
		return this.__receptor;
	}
	set detalle(x) {
		if(!(x instanceof Objects.Detalle)) { 
			throw new Error(`Atributo emisor no es instancia de Detalle`);
		}
		this.__detalle = x;
	}
	get detalle() {
		return this.__detalle;
	}
	set vendedor(x) {
		if((x!==undefined) && (x.length < 1)) {
			throw new Error(`Atributo venededor no es undefined, o tiene un largo inferior a 1 (${x})`);
		}
		this.__vendedor = x;
	}
	get vendedor() {
		return this.__vendedor;
	}
	set meta(x) {
		// Solicitado por rroman 16-feb-2021. Campo acepta cualquier cosa JSON-serializable.
		this.__meta = x;
	}
	get meta() {
		return this.__meta;
	}
	payload() {
		let idDocumento = new Objects.IdentificadorDocumento(this.tipoDte);
		let payloadData = {
			'vendedor': this.vendedor,
			'Encabezado': {
				'IdDoc': idDocumento.payload(),
				'Emisor': this.emisor.payload(),
				'Receptor': this.receptor.payload(),
			},
			'Detalle': this.detalle.payload(),
			'Meta': this.meta, // Solicitado por rroman 16-feb-2021.
		};
		return payloadData;
	}
	set dteFinalSuccessCallback(x) {
		if((typeof x !== 'function') && (x !== undefined)) { 
			throw new Error(`Atributo dteFinalSuccessCallback no es una función o undefined`);
		}
		this.__dteFinalSuccessCallback = (x === undefined) ? DUMMY_FUN : x;
	}
	get dteFinalSuccessCallback() {
		return this.__dteFinalSuccessCallback;
	}
	set dteFinalFailCallback(x) {
		if((typeof x !== 'function') && (x !== undefined)) { 
			throw new Error(`Atributo dteFinalFailCallback no es una función o undefined`);
		}
		this.__dteFinalFailCallback = (x === undefined) ? DUMMY_FUN : x;
	}
	get dteFinalFailCallback() {
		return this.__dteFinalFailCallback;
	}
	emitir() {
		let self = this;
		let dteFinalPayload = self.payload();
		let method = 'POST';
		let data = dteFinalPayload;
		let url = ApiBoletas.añadirUrlBase(ApiBoletas.urlDteFinal());
		let thenFun = function(response) {
			let dteFinalData = response.data;
			self.dteFinalSuccessCallback(dteFinalData);
		};
		let catchFun = function(error) {
			if(error.response) {
				// Error generado por respuesta con código HTTP no exitoso. Se asegura que response existe.
				self.dteFinalFailCallback(error.response.data);
			}
			else {
				// Error generado por otras causas. No se asegura existencia de response.
				self.dteFinalFailCallback(error);
			}
		};
		AwsSigningUtils.executeJSONSignedRequest(method, url, data, thenFun, catchFun);
	}
}


export class BoletaSimple extends Boleta {
	constructor(tipoDte, emisor, monto) {
		let rutReceptor = new Objects.RUT(RECEPTOR_GENERICO.RUT, RECEPTOR_GENERICO.DV);
		let razonSocialReceptor = RECEPTOR_GENERICO.RAZON_SOCIAL;
		let comunaReceptor = RECEPTOR_GENERICO.COMUNA;
		let direccionReceptor = RECEPTOR_GENERICO.DIRECCION;
		let receptor = new Objects.Receptor(rutReceptor, razonSocialReceptor);
		receptor.comuna = comunaReceptor;
		receptor.direccion = direccionReceptor;
		let item = new Objects.ItemDetalle('Venta', 1, monto);
		let detalle = new Objects.Detalle();
		detalle.añadirItem(item);
		super(tipoDte, emisor, receptor, detalle);
	}
	// Luego de instanciación no es necesario establecer nada más,
	// sólo queda invocar a emitir.
}
